import { useFormField } from '../useFormField'

export const File = allProps => {
  const {
    props: { accept, onChange },
    setFieldTouched,
    setFieldValue,
    name,
    labelClasses,
    label,
    fieldError,
    formGroupClasses,
    fromLibraries: { classnames },
  } = useFormField(allProps)
  const uploadHandler = e => {
    setFieldValue(name, e.target.files[0])
      .then(() => setFieldTouched(name))
      .then(onChange && onChange(e.target.files[0]))
  }
  return (
    <div className={classnames('mb-3', formGroupClasses)}>
      {label && (
        <label htmlFor={name} className={classnames('form-label', labelClasses)}>
          {label}
        </label>
      )}
      <>
        <input
          className={classnames('form-control', fieldError && 'is-invalid')}
          accept={accept}
          type="file"
          onChange={uploadHandler}
        />
        {/* <label className="form-file-label">{field.value && field.value.name}</label> */}
        {fieldError && <small className="form-text text-danger">{fieldError}</small>}
      </>
    </div>
  )
}
